import axios from "axios";
import { useEffect, useState } from "react";

import Table from 'react-bootstrap/Table';

function Subscriptions() {
    const [subscription, setSubscription] = useState([])

    const user = JSON.parse(localStorage.getItem("user"));
    console.log(user.accessToken);

    useEffect(()=>{
        axios
            .get('https://coda.easylinksmw.com/api/subscriptions/getSubscriptions', {headers : {authorization : "Bearer " + user.accessToken}})
            .then((res)=>{console.log(res);
            setSubscription(res.data);
            })
            .catch((err)=>console.log(err))
    }, []);

    return (
        <div className="subscription-listing">
            <div><center><blockquote><b>Subscription Listing</b> </blockquote></center> </div>
            <Table striped bordered hover variant="light">
            <thead>
                <tr>
                <th>Email</th>
                <th>Subscription Date</th>
                <th>Subscription Status</th>
                </tr>
            </thead>
            {
                subscription && subscription.map((subscription)=> (
                    <tbody key={subscription.id}>
                        <tr>
                            <td>{subscription.student.email}</td>
                            <td>{subscription.subscription_date}</td>
                            <td>{subscription.subscription_status}</td>
                        </tr>
                    </tbody>
                ))
            }
            </Table>
        </div>
    );
}

export default Subscriptions;